import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import * as L from 'leaflet';
import { BaseFormComponent } from '../../../base-form.component';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';

const iconUrl = 'assets/img/marker-icon.png';
const Defaulticon = L.icon({
    iconUrl,
    iconSize: [25, 25],
    iconAnchor: [5, 20],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28]
});
const ContainerFormIcon = L.Icon.extend({
    options: {
        iconSize: [25, 25],
        iconAnchor: [5, 20],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28]
    }
})
L.Marker.prototype.options.icon = Defaulticon;

@Component({
    selector: 'app-set-start-location-form',
    templateUrl: './set-start-location-form.component.html',
    styleUrls: ['./set-start-location-form.component.scss']
})
export class SetStartLocationComponent extends BaseFormComponent implements OnInit {
    private map;
    public selectedLocation: L.LatLng;
    public markerOpen = false;
    constructor(
        public _translateService:TranslateService,
        @Inject(MAT_DIALOG_DATA) public data:any,
        public _toastService: ToasterService
    ) {
        super();
    }

    ngOnInit(): void {
        this.initMap();
    }


    public get MapTileUrl(): string {
        return 'http://tile.openstreetmap.org/{z}/{x}/{y}.png';
    }

    private async initMap(): Promise<void> {
        this.map = L.map('map', {
            center: [39.09766, 34.56039],
            zoom: 8
        });

        const tiles = L.tileLayer(
            this.MapTileUrl, {
            maxZoom: 19,
            minZoom: 5,
            attribution: 'AKILLI-ATIK-SİSTEMİ'
        });

        tiles.addTo(this.map);

        setTimeout(() => {
            const marker = L.marker([this.data.lat, this.data.lng], {
                icon: new ContainerFormIcon({ iconUrl: 'assets/img/marker.png' })
            });
            marker.addTo(this.map)
            this.map.setView(new L.LatLng(this.data.lat, this.data.lng), 19)
        }, 1000)
        this.map.on("click", async e => {
            if (this.markerOpen == true) {
                this.selectedLocation = e.latlng;
                this.updated.emit(this.selectedLocation)
            }

        });

    }

    public onUpdateLocationClick(e) {
        this.markerOpen = true;
        this._toastService.toastWarning(this._translateService.instant("MARKING_IS_ACTIVE_PLEASE_MARK_A_LOCATION_ON_THE_MAP"));
        e.stopPropagation();
    }

    public onAddLocationClick(e) {
        this.selectedLocation = new L.LatLng(this.data.lat, this.data.lng)
        this.updated.emit(this.selectedLocation)
        e.stopPropagation();
    }

    public onCancelLocationClick(e) {
        this.markerOpen = false;
        this._toastService.toastFail(this._translateService.instant("MARKING_IS_PASSIVE"));
        e.stopPropagation()
    }

}
